<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import TreatmentDwellTimePageTable from './TreatmentDwellTimePageTable'
const { CrudLayoutSearch } = JtCrud

@Component({
  name: 'TreatmentDwellTime',
  mixins: [CrudLayoutSearch],
  components: {
    TreatmentDwellTimePageTable
  }
})
class TreatmentDwellTime extends Vue {
  get _pageTable () {
    return TreatmentDwellTimePageTable
  }

  async actionButton (button, params, page) {
    await this.actionButtonDefault(button, { ...this.params, ...params }, page)
  }
}
export default TreatmentDwellTime
</script>
<style lang="stylus" scoped></style>
